export const randomFloat = (min, max) => {
    const difference = max - min;
    const rand = Math.random();
    return Math.floor(rand * difference) + min;
};
//# sourceMappingURL=random-float.js.map